import { render, staticRenderFns } from "./undoSplit.vue?vue&type=template&id=29da380d&scoped=true&"
import script from "./undoSplit.vue?vue&type=script&lang=js&"
export * from "./undoSplit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29da380d",
  null
  
)

export default component.exports